<template>

<core-filter-advanced 
    :active="isActive" 
	filter="collection"
    :has-close="true" 
    :has-reset="true" 
    :has-advanced="$hasEarly('advanced_filter')"
    v-on:clickoutside="onOutsideClick" 
    v-on:close="onOutsideClick" 
    v-on:reset="onResetClick"
>

	<template v-slot:inputs>

		<core-filter-advanced-inputs>

			<core-filter-input-text filter="collection/text" :inline="true" />
			
		</core-filter-advanced-inputs>
			
		<core-filter-advanced-inputs>

			<core-filter-advanced-title>Games</core-filter-advanced-title>

			<app-filter-template-games-general filter="collection" />

			<app-filter-template-games-count filter="collection" />

			<app-filter-template-games-language filter="collection" />

			<app-filter-template-games-age filter="collection" />
				
			<app-filter-template-games-include filter="collection" />

			<app-filter-template-games-exclude filter="collection" />

		</core-filter-advanced-inputs>
			
		<core-filter-advanced-inputs>

			<core-filter-advanced-title>Collection</core-filter-advanced-title>

			<app-filter-template-collection-general filter="collection" />

			<app-filter-template-collection-status filter="collection" />

			<app-filter-template-collection-worth filter="collection" />
				
			<app-filter-template-collection-inventory filter="collection" />

			<app-filter-template-common-tags filter="collection" />

			<app-filter-template-common-tagfamilies filter="collection" />

			<app-filter-template-collection-owners filter="collection" />
				
			<app-filter-template-collection-trades filter="collection" />

		</core-filter-advanced-inputs>
			
		<core-filter-advanced-inputs>

			<core-filter-advanced-title>Ratings</core-filter-advanced-title>

			<app-filter-template-collection-user filter="collection" />

			<app-filter-template-collection-group filter="collection" />

			<app-filter-template-collection-community filter="collection" />

			<app-filter-template-collection-comments filter="collection" />

		</core-filter-advanced-inputs>
			
		<core-filter-advanced-inputs>

			<core-filter-advanced-title>Plays</core-filter-advanced-title>

			<app-filter-template-collection-plays filter="collection" :range="true" />

		</core-filter-advanced-inputs>
			
		<core-filter-advanced-inputs>
			
			<core-filter-advanced-title>Other</core-filter-advanced-title>

			<app-filter-template-common-users filter="collection" />

			<app-filter-template-common-designers filter="collection" />
				
			<app-filter-template-common-artists filter="collection" />
				
			<app-filter-template-common-publishers filter="collection" />
				
			<app-filter-template-common-categories filter="collection" />
			
			<app-filter-template-common-mechanics filter="collection" />
				
			<app-filter-template-common-subdomains filter="collection" />

			<app-filter-template-common-families filter="collection" />
				
			<app-filter-template-common-results filter="collection" />

		</core-filter-advanced-inputs>

	</template>

</core-filter-advanced>

</template>

<script>

export default {

    props: ['isActive'],

    watch: {

        isActive: function(n) {

            if (n) this.$pubsub.$emit('filter.opened')

        }

    },

	methods: {

		onOutsideClick: function() {

			this.$emit('close')

		},

		onResetClick: function() {

			this.$emit('reset')

		}

	}

}

</script>

<style scoped>

.filter-text {
	font-size: 12px;
    display: block;
    color: #fff;
    font-weight: 400;
    padding-bottom: 8px;
}

.filter-search-mobile {
	margin: 4px 7px 0px 7px!important;
	width: calc(100% - 16px)!important;
}

@media only screen and (max-width: 767px) {

	.filter-section-first {
		margin-top: 4px;
		border-top: 1px solid rgba(255, 255, 255, 0.1);
	}

}

</style>
